export default __webpack_public_path__ + "static/media/mobile-service.1865ecc1.jpeg";